import { animate, state, style, transition, trigger } from "@angular/animations"
import {
    AfterContentInit,
    Component,
    ContentChild,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from "@angular/core"
import { StickyNavbar, StickyNavbarContent, StickyNavbarTrigger } from "./sticky-navbar.model"
import { StickyNavbarService } from "./sticky-navbar.service"

@Component({
    selector: "app-sticky-navbar",
    templateUrl: "./sticky-navbar.component.html",
    styleUrls: ["./sticky-navbar.component.scss"],
    animations: [
        trigger("inOutAnimation", [
            state("in", style({ transform: "translateY(0)" })),
            transition("void => *", [style({ transform: "translateY(-100%)" }), animate(300)]),
            transition("* => void", [animate(300, style({ transform: "translateY(-100%)" }))]),
        ]),
    ],
    standalone: false,
})
export class StickyNavbarComponent implements OnInit, AfterContentInit, OnDestroy, StickyNavbar {
    public isVisible = false

    @ContentChild(StickyNavbarContent, { static: true })
    public navbarContent: StickyNavbarContent

    @Input()
    public height: number

    @Output()
    public triggerUpdate = new EventEmitter()

    constructor(private navbarService: StickyNavbarService) {}

    public ngOnInit() {
        this.navbarService.registerNavbar(this)
    }

    public ngAfterContentInit() {
        this.navbarContent.height = this.height
    }

    public ngOnDestroy() {
        this.navbarService.deregisterNavbar()
    }

    public show() {
        this.isVisible = true
    }

    public hide() {
        this.isVisible = false
    }

    public update(trigger: StickyNavbarTrigger) {
        this.navbarContent.update(trigger)
    }
}
